<template>
  <el-dialog
    width="40%"
    :visible="dialogVisible"
    @close="$emit('update:dialogVisible', false)"
  >
    <template #default>
      <div style="display: flex;justify-content: center">
        <img :class="[className]" :src="info.imgUrl" alt="" />
        {{ info.title }}
      </div>
    </template>
  </el-dialog>
</template>

<script>
  export default {
    name: 'Details',
    props: {
      dialogVisible: {
        type: Boolean,
        required: true,
      },
      info: {
        type: Object,
        required: true,
      },
      className: {
          type: String,
          default: ''
      }
    },
  }
</script>

<style scoped lang="scss">
.img{
  width: 80%;
  margin: 0 auto;
}
</style>
